import { useContext } from 'react';

import { ShiftContext } from '@/providers';

function useShifts() {
  return useContext(ShiftContext);
}

export default useShifts;
